module.exports = __webpack_public_path__ + "static/media/spinner.3656ecf0.gif";